import React, { Component } from 'react';
import { shareLeagueOnFacebook, shareLeagueOnTwitter } from './../../share';
import common from '../../common';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import config from '../../config';
import trackEventsObj from '../../constants/new-pageTrackEvents'

class LeagueShare extends Component {
    state = {
        copied: false,
        linkCopied: false
    }

    componentDidMount() {
        common.pageViewTracking("", trackEventsObj["LeagueInviteLayer"]);
    }

    onCopy() {
        this.setState({ copied: true }, () => {
            if(this.props.isFromSettings){
                common.customTracking('Share - Copy Code', '/uclfantasy/leagues/private/settings/');
            }
            else{
                common.customTracking('Share - Copy Code', '/uclfantasy/leagues/');
            }
            
            setTimeout(() => {
                this.setState({ copied: false })
            }, 2000)
        })
    }

    onCopyLink() {
        this.setState({ linkCopied: true }, () => {
            if(this.props.isFromSettings){
                common.customTracking('Share - Copy Link', '/uclfantasy/leagues/private/settings/');
            }
            else{
                common.customTracking('Share - Copy Link', '/uclfantasy/leagues/');
            }
            
            setTimeout(() => {
                this.setState({ linkCopied: false })
            }, 2000)
        })
    }

    render() {
        let { trans, LeagueCode, LeagueId, LeagueName, ShareLoad, constraints } = this.props;
        const tooltipClass = common.makeClasses({
            'si-copy-tt': true,
            'si-up': true,
            'si-active': this.state.copied
        });
        const tooltipLinkClass = common.makeClasses({
            'si-copy-tt': true,
            'si-up': true,
            'si-active': this.state.linkCopied
        });
        let isEot = common.isEndOfSeason(constraints.GamercardSubScenario);
        let linkShareMsg = (trans['shareLeagueLinkMsg'] || "Join my official UCL {game_name} league! Use the code: {league_code} or the link below. Let's see who's really the best! {league_link}").replace("{game_name}", config.gameName).replace("{league_code}", LeagueCode).replace("{league_link}", ShareLoad)
        return (
            <div className="si-modal-wrap">
                <div className="si-common-popup si-left-border">
                    <i className="si-close icon-ucl-close" onClick={ () => this.props.toHide() }></i>
                    <div className="si-popup-body si-flexBox">
                        <div className="si-leagues-card si-ls">
                            <div className="si-league-head">
                                <span className="si-league-title">{ trans['inviteYourFrnds'] || "Invite your friends" }</span>
                            </div>

                            <div className="si-league-body">
                                <div className="si-social-share">
                                    <span className="si-ls__title">{ trans['leagueLink'] || "League link" }</span>
                                    <span className="si-ls__desc">{ trans['inviteFriendsToLeague'] || "Invite friends to your league whenever you want by sharing this link." }</span>
                                    <div className="si-ls__code">{ (ShareLoad) }</div>
                                    <div className="si-share-med" style={ isEot ? common.hideVisibility() : {} }>
                                        <div className={ tooltipLinkClass }>
                                            <CopyToClipboard text={ linkShareMsg } onCopy={ () => this.onCopyLink() }>
                                                <div className="si-btn si-btn-primary">{ trans['shareLink'] || "Share link" }</div>
                                            </CopyToClipboard>
                                            <div className="si-tooltip">
                                                <div className="si-tt-desc">{ trans['league_copy2clip'] || "Copied to clipboard!" }</div>
                                            </div>
                                        </div>

                                        <div className="si-share-item si-fb-share" onClick={ (e) => {
                                            if(this.props.isFromSettings){
                                                common.customTracking('Share - Facebook', '/uclfantasy/leagues/private/settings/');
                                            }
                                            else{
                                                common.customTracking('Share - Facebook', '/uclfantasy/leagues/');
                                            }
                                            
                                            shareLeagueOnFacebook(e, LeagueCode, LeagueId, LeagueName, ShareLoad, trans)
                                        } }>
                                            <i className="icon-ucl-facebook" ></i>
                                        </div>
                                        <div className="si-share-item si-tweet-share" onClick={ (e) => {
                                             if(this.props.isFromSettings){
                                                common.customTracking('Share - Twitter', '/uclfantasy/leagues/private/settings/');
                                            }
                                            else{
                                                common.customTracking('Share - Twitter', '/uclfantasy/leagues/');
                                            }
                                            shareLeagueOnTwitter(e, LeagueCode, LeagueId, LeagueName, ShareLoad, trans)
                                        
                                        } }>
                                            <i className="icon-ucl-twitter"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="si-join-code">
                                    <span className="si-ls__title">{ trans['leagueCode'] || "League code" }</span>
                                    <span className="si-ls__desc">{ trans['yourFrndsCanAlsoJoin'] || "Your friends can also join by entering this code." }</span>
                                    <div className="si-code-wrp">
                                        <span>{ LeagueCode }</span>
                                        <div className={ tooltipClass }>
                                            <CopyToClipboard text={ LeagueCode } onCopy={ () => this.onCopy() }>
                                                <div className="si-btn si-btn-secondary-wb">{ trans['copy'] || "Copy" }</div>
                                            </CopyToClipboard>
                                            <div className="si-tooltip">
                                                <div className="si-tt-desc">{ trans['league_copy2clip'] || "Copied to clipboard!" }</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LeagueShare;


// WEBPACK FOOTER //
// ./src/components/leagues/league-share.js